import { PLAYER } from "../../../common/constants.ts";
import type { Player } from "../../../common/types.ts";
import { g } from "../../util/index.ts";
import { minorLeagueReady } from "../player/minorsSatisfaction.ts";
import { rankRosterCandidates } from "./rosterComposition.baseball.ts";
import { minorsStatus } from "./minorsComposition.baseball.ts";

export type MinorMarketPlayer = Player & { minorMarketReview?: { season: number; phase: number; day: number } };

// Preserve the affiliate's existing minimum and positional coverage; age alone never forces a release.
export const minorLeaguePlan = (p: Player, roster: Player[], minors: Player[], benchmarks: Map<string, number>) => {
	if (p.injury.gamesRemaining > 0) return "recovery";
	if (rankRosterCandidates(roster, [p], g.get("maxRosterSize"), g.get("dh") !== "none", 0.5).length > 0) return "promotion";
	if (g.get("season") - p.born.year < 25 || !minorLeagueReady(p, benchmarks)) return "development";
	const min = g.get("minMinorsSize") ?? 0;
	const before = minorsStatus(minors, min).short;
	const after = minorsStatus(minors.filter((other) => other.pid !== p.pid), min).short;
	if (Object.keys(before).some((key) => after[key as keyof typeof after] > before[key as keyof typeof before])) return "coverage";
	return "blocked";
};

export const minorMarketReviewDue = (p: MinorMarketPlayer, day: number) => {
	const last = p.minorMarketReview;
	return p.tid === PLAYER.MINORS && (!last || last.season !== g.get("season") || last.phase !== g.get("phase") || day - last.day >= 7);
};
